import React from "react";
import { Link, useNavigate } from "react-router-dom";

import { Button, Stack, Box, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import LogoutIcon from "@mui/icons-material/Logout";

import useAuth from "../../hooks/useAuth";
import { allItemTop } from "../../constants/navbarList";
import { getLogoPath, isTextchest } from "../../partners";

const TopNavBar = ({ handleDrawerToggle }) => {
  const { user } = useAuth();
  const nav = useNavigate();
  const logo = getLogoPath();

  const visibleNavItems = allItemTop.filter((eachItem) => {
    const baseAllowed =
      (eachItem.isSuperUserView && user.admin && user.id === 1) ||
      (eachItem.isAdminView && user.admin) ||
      (!eachItem.isSuperUserView &&
        !eachItem.isAdminView &&
        !eachItem.onlyUserView) ||
      (eachItem.onlyUserView && !user.admin && user.id !== 1);

    if (eachItem.to === "/gateway" && user && user.has_gateways === false) {
      return false;
    }
    return baseAllowed;
  });

  const listItemTop = [
    ...visibleNavItems,
    {
      text: "Logout",
      to: "/login",
      icon: <LogoutIcon />,
      hasNoLink: true,
      onclick: () => {
        localStorage.clear();
        nav("/login");
      },
    },
  ];

  return (
    <>
      {/* Mobile hamburger */}
      <IconButton
        color="inherit"
        aria-label="open drawer"
        edge="start"
        onClick={handleDrawerToggle}
        sx={{ mr: 2, display: { sm: "none" } }}
      >
        <MenuIcon />
      </IconButton>

      {/* Desktop nav — logo left + buttons right for TextChest; buttons left for default */}
      <Box
        sx={{
          display: { xs: "none", sm: "flex" },
          alignItems: "center",
          width: "100%",
        }}
      >
        {logo && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mr: 2 }}>
            <Box
              component="img"
              src={logo}
              alt="Logo"
              sx={{ height: 30, width: 30, objectFit: "contain" }}
            />
            {isTextchest() && (
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 700, color: "primary.main", lineHeight: 1 }}
              >
                TextChest
              </Typography>
            )}
          </Box>
        )}

        <Stack direction="row" spacing={2} sx={{ ml: logo ? "auto" : 0 }}>
          {listItemTop.map((list) => (
            <Button
              color="inherit"
              key={list.text}
              component={Link}
              to={list.to}
              onClick={list?.onclick}
            >
              {list.text}
            </Button>
          ))}
        </Stack>
      </Box>
    </>
  );
};

export default TopNavBar;
